import React, { useState, useEffect } from "react";

import "./styles.css";


const HomepageFadeText = () => {

    const firstHeader = ["Creating Content", "Learning", "Visualising", "Feedback", "Relations"];
    const secondHeader = ["Made Easy", "Made Fun", "Simplified"];

    const fadeInterval = 3000;
    const wordInterval = fadeInterval / 2;

    const [fadeProp, setFadeProp] = useState({ fade: "fade-in"});
    const [firstHeaderOrder, setFirstHeaderOrder] = useState(0);
    const [secondHeaderOrder, setSecondHeaderOrder] = useState(0);

    useEffect(() => {
        const fadeTimeout = setInterval(() => {
          fadeProp.fade === 'fade-in' ? setFadeProp({ fade: 'fade-out' }) : setFadeProp({ fade: 'fade-in' })
        }, fadeInterval)
    
        return () => clearInterval(fadeTimeout)
      }, [fadeProp]);

      useEffect(() => {
        const wordTimeout = setInterval(() => {
            setFirstHeaderOrder((prevWordOrder) => (prevWordOrder + 1) % firstHeader.length)
        }, (fadeInterval * 2))
    
        return () => clearInterval(wordTimeout)
      }, []);

      useEffect(() => {
        const wordTimeout = setInterval(() => {
            setSecondHeaderOrder((prevWordOrder) => (prevWordOrder + 1) % secondHeader.length)
        }, (fadeInterval * 2))
    
        return () => clearInterval(wordTimeout)
      }, []);

return (
    <div>
    <div className="homeContainer">

    {/* .fade-in {
    transition: opacity 3s ease;
  }
  
  .fade-out {
    opacity: 0;
    transition: opacity 3s ease;
  } */}




    <h1 
        className={fadeProp.fade}
        style={{
            textAlign: "center",
            paddingTop: "20vw",
            paddingLeft: "20vw",
            fontSize: "63px",
            textShadow: "2px 2px 10px #fff"
        }}    
    >{firstHeader[firstHeaderOrder]}</h1>

    <h2 
        className={fadeProp.fade}
        style={{
            textAlign: "center",
            paddingRight: "20vw",
            textShadow: "2px 2px 10px #fff"
        }}    
    >{secondHeader[secondHeaderOrder]}</h2>

    </div>
    </div>
    );
};

export default HomepageFadeText;